/*
 * @Author: Teemo Ding
 * @Date: 2021-06-24 14:31:18
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-28 17:35:24
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/storeDetails/index.ts
 */
import { get, post } from 'src/tools/server';

export const getStoreDetails = () => {
  return get<any>(`/portal/setting/store/details`, {});
};

export const submitStoreDetails = (data) => {
  return post<any>(`/portal/setting/store/details`, data, {});
};

export const getCountry = (languageTag) => {
  return get<any>(`/portal/language/country/${languageTag}`, {});
};

export const getState = (countryCode) => {
  return get<any>(`/portal/subdivisions/${countryCode}`, {});
};

export const getCity = (provinceUuid) => {
  return get<any>(`/portal/cities/${provinceUuid}`, {});
};
